import React from "react";
import ProjectContentBox from "./ProjectContentBox";

export default function Projects() {
  const StatArbProjects = [
    {
      id: 0,
      title: "IMC Prosperity 3 Trading Competition",
      projectURL:
        "https://medium.com/@johnnya12399/how-we-ranked-top-2-globally-in-imc-prosperity-2025-our-algorithmic-trading-strategy-957377749621",
      githubURL:
        "https://github.com/JohnnyTung123/imc-prosperity-3/tree/main?tab=readme-ov-file",
      description: [
        "Ranked top 2.5% globally out of 12,621 teams in a multi-round simulated market trading challenge",
        "Built algorithmic trading strategies in market making, statistical arbitrage, and options volatility trading across multiple asset classes using Python",
        "Leveraged counterparty trading behavior to generate momentum signals, improving portfolio returns",
      ],
      thumbnail: "/images/imc-prosperity.png",
    },
    {
      id: 1,
      title: "Statistical Arbitrage in Cryptocurrencies",
      projectURL:
        "https://medium.com/@johnnya12399/statistical-arbitrage-in-cryptocurrencies-part-1-7ed626ed9629",
      githubURL:
        "https://github.com/JohnnyTung123/Statistical-Arbitrage-in-Cryptocurrencies",
      description: [
        "Created a pairs trading strategy in Python trading 300+ cryptos with a 1.57 backtested SR (net), 9-day holding period, and significant alpha, under mentorship of an ex-Point72 quant researcher",
        "Applied k-means clustering and correlation / cointegration analysis to find highly-correlated pairs and constructed a trading signal using residual returns (from lin reg).",
        "Cleaned & prepared intraday pricing data for 1,000 cryptos from 2018-2024.",
      ],
      thumbnail: "/images/pairs-trading.png",
    },
    {
      id: 2,
      title: "Momentum Strategies in U.S. Equities",
      projectURL: "",
      githubURL:
        "https://github.com/JohnnyTung123/-Momentum-Strategies-in-U.S.-Equities",
      description: [
        "Developed a breakout strategy in the top 500 US Equities with a 0.7 backtested SR (net).",
        "Back-tested a moving average crossover strategy and performed sensitivity analysis to determine the optimal lookback window for the moving averages.",
      ],
      thumbnail: "/images/CRB-trading.png",
    },
  ];

  return (
    <>
      <div id="skills-container" className="p-4 md:ml-12 pb-2">
        <h4 className="text-md md:text-xl tracking-[4px] underline underline-offset-4 font-semibold mb-10">
          Stat Arb Projects
        </h4>
        <div className="flex flex-row-reverse justify-center md:justify-end h-fit relative">
          <ol className="w-full relative max-w-7xl">
            {StatArbProjects.map((project) => (
              <ProjectContentBox key={project.id} content={project} />
            ))}
          </ol>
        </div>
      </div>
    </>
  );
}
